<template>
  <div class="export" v-loading="loading">
    <div class="export__header">
      <span class="title">EXCEPTION REPORT</span>
    </div>
    <div class="export__footer">
      <el-row :gutter="15">
        <el-col :span="24">
          <div class="collapse-header">
            <div class="header-section border-line">
              <ul class="data-include-sub-header">
                <li class="checkbox-sub-header">Data Includes:</li>
                <li class="search-checkbox">
                  <el-checkbox v-model="checkAll" disabled>Check All</el-checkbox>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="inputs pl-20 mt-20">
      <el-row :gutter="20">
        <el-form>
          <el-col>
            <div class="case-creation__input">
              <el-form-item>
                <label>Ordering Facility</label>
                <el-select
                  :key="selectKey"
                  ref="hospitalSelect"
                  placeholder="Select Ordering Facility"
                  v-model="hospital"
                  @change="onFacilitySelect"
                  @clear="onFacilityClear"
                  @visible-change="onDropdownToggle"
                  filterable
                  :filter-method="filterFacility"
                  collapse-tags
                  clearable
                  style="width: 100%;"
                >
                  <el-option
                    v-for="facility in filteredHospitals"
                    :key="facility._id"
                    :label="facility.name"
                    :value="facility._id"
                  />
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col v-if="hospital">
            <div class="case-creation__input">
              <el-form-item>
                <label>Account Managers</label>
                <el-select
                  placeholder="Select Account Manager"
                  v-model="selectedUser"
                  filterable
                  multiple
                  collapse-tags
                  clearable
                  style="width: 100%;"
                >
                  <el-option
                    v-for="user in hospitalAdmins"
                    :key="user._id" 
                    :label="user.first_name + ' ' + user.last_name"
                    :value="user.email"
                  >
                    <!-- Custom slot for label to ensure proper rendering and spacing -->
                    <span style="float: left">{{ user.first_name + ' ' + user.last_name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col> 
          <el-col v-if="selectedUser && selectedUser.length > 0">
            <div class="case-creation__input">
              <el-form-item>
                <label>Sales Reps</label>
                <el-select
                  placeholder="Select Sales Reps"
                  v-model="selectedEmails"
                  filterable
                  collapse-tags
                  multiple
                  style="width: 100%;"
                >
                  <el-option
                    v-for="email in filteredEmails"
                    :key="email.email"
                    :label="email.first_name + ' ' + email.last_name"
                    :value="email.email"
                  >
                    <span style="float: left">{{ email.first_name + ' ' + email.last_name }}</span>
                    <span
                      v-if="email && email.user_type == 'SALES_DIRECTOR'"
                      style="float: right; color: #eb5757; font-size: 13px; padding-left: 10px;"
                    >
                      {{ userTypeMap[email.user_type] }}
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-button
            class="download-button"
            @click="findPopup"
            :disabled="loading || !selectedUser || selectedUser.length === 0"
            :loading="loading"
          >
            Find Data
          </el-button> 
        </el-form>
      </el-row>
    </div>

    <ExceptionPopup
      v-model:visible="exceptionDialogVisible" 
      :facility-id="hospital" 
      :emails="selectedEmails" 
      :managers="selectedUser"
      @popup-closed="onPopupClosed"
    />

    <div class="export__footer">
      <el-collapse v-model="caseReportCollapse">
        <el-row :gutter="15">
          <el-col :span="24">
            <div class="collapse-header">
              <el-collapse-item name="1">
                <div class="date-includes">
                  <el-checkbox-group v-model="activeFieldList">
                    <ul class="check-list">
                      <li
                        v-for="(item, index) in casesExportFields"
                        :key="index"
                        class="search-checkbox"
                      >
                        <el-checkbox
                          :label="item.value"
                          v-model="item.checked"
                          :disabled="true"
                        >
                          {{ item.label }}
                        </el-checkbox>
                      </li>
                    </ul>
                  </el-checkbox-group>
                </div>
              </el-collapse-item>
            </div>
          </el-col>
        </el-row>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ExceptionPopup from "@/components/reports/ExceptionPopup.vue";
import userConstants from "@/config/constants/userConstants";
export default {
  components: { ExceptionPopup },
  data() {
    return {
      checkAll: true,
      caseReportCollapse: "1",
      hospital: "",
      selectedUser: [],      // selected facility users
      hospitalsData: {},
      filteredHospitals: [],
      usersData: [],
      activeFieldList: [],
      casesExportFields: [
        { label: "Accession ID", value: "accession_id", checked: true },
        { label: "Insurance Name", value: "insurance_name", checked: true },
        { label: "Policy No", value: "policy_no", checked: true },
        { label: "Exception Comments", value: "exception_comments", checked: true },
        { label: "Case Type", value: "case_type", checked: true },
        { label: "Date of Service", value: "date_of_service", checked: true },
        { label: "Ordering Facility", value: "ordering_facility", checked: true },
        { label: "Patient DOB", value: "patient_dob", checked: true },
        { label: "Patient First Name", value: "patient_first_name", checked: true },
        { label: "Patient Last Name", value: "patient_last_name", checked: true },
        { label: "Patient Gender", value: "patient_gender", checked: true },
      ],
      exceptionDialogVisible: false,
      selectedEmails: [],    // manually chosen Sales Reps emails
      filteredEmails: [],    // emails shown in Sales Reps dropdown
      userTypeMap: userConstants.userTypeMap,
      loading:false,
      selectKey: 0  // Key to force re-render of el-select on clear
    };
  },
  computed: {
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    hospitalAdmins() {
      return this.usersData.filter(
        (user) => user.status === "ACTIVE" && user.user_type === "ACCOUNT_MANAGER"
      );
    },
  },
  async mounted() {
    await this.fetchAllHospitals();
    this.activeFieldList = this.casesExportFields.map((f) => f.value);
  },
  methods: {
    onFacilityClear() {
      // Reset filtered hospitals to original list
      this.filteredHospitals = [...this.hospitalsData.data];

      // Clear dependent dropdowns
      this.selectedUser = [];
      this.selectedEmails = [];
      this.filteredEmails = [];
      this.usersData = [];

      // Force re-render of the select component
      this.selectKey += 1;

      // Reset search input inside el-select and trigger filter
      this.$nextTick(() => {
        if (this.$refs.hospitalSelect) {
          // Clear the input value directly
          const input = this.$refs.hospitalSelect.$el.querySelector('input');
          if (input) {
            input.value = '';
          }
          // Reset internal properties
          this.$refs.hospitalSelect.inputValue = '';
          this.$refs.hospitalSelect.query = '';
          // Dispatch input event to trigger filter-method with empty query
          if (input) {
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
          // Reset scroll position of dropdown if open
          const dropdown = this.$refs.hospitalSelect.selectWrapper;
          if (dropdown) {
            dropdown.scrollTop = 0;
          }
          // Close dropdown if open
          this.$refs.hospitalSelect.visible = false;
        }
      });
    },
    async fetchAllHospitals() {
      this.loading = true
      try {
        await this.$store.dispatch("hospitals/fetchAllHospitals", { get_all: true });
        this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
        this.filteredHospitals = [...this.hospitalsData.data];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false
      }
    },
    filterFacility(query) {
      if (!query || query.trim() === '') {
        this.filteredHospitals = [...this.hospitalsData.data];
      } else {
        const lowerQuery = query.toLowerCase().trim();
        this.filteredHospitals = this.hospitalsData.data.filter(facility =>
          facility.name.toLowerCase().includes(lowerQuery)
        );
      }
    },
    onDropdownToggle(isVisible) {
      if (!isVisible) {
        this.filteredHospitals = [...this.hospitalsData.data];
        // Reset scroll on close
        this.$nextTick(() => {
          const dropdown = this.$refs.hospitalSelect.selectWrapper;
          if (dropdown) {
            dropdown.scrollTop = 0;
          }
        });
      }
    },
    async onFacilitySelect(facilityId) {
      this.selectedUser = [];
      this.selectedEmails = [];
      this.filteredEmails = [];

      // Fetch all facility admins first
      await this.$store.dispatch("userAccounts/fetchAllUserAccounts", {
        hospitals: [facilityId],
        get_all: true,
        user_types: [
          "ACCOUNT_MANAGER",
        ],
        order_by: "first_name",
        order_type: "asc",
        status:"ACTIVE"
      });
      let res = JSON.parse(JSON.stringify(this.getAllUsers.data || []));

      // Deduplicate by email (email is unique)
      const uniqueUsers = res.reduce((acc, current) => {
        const existingIndex = acc.findIndex(item => item.email === current.email);
        if (existingIndex === -1) {
          acc.push(current);
        }
        return acc;
      }, []);

      this.usersData = uniqueUsers;
    },
    async loadSalesRepEmails() {
      try {
        // Clear existing sales reps first
        this.filteredEmails = [];
        // Fetch sales reps for the selected hospital
        await this.$store.dispatch("userAccounts/fetchAllUserAccounts", {
          hospitals: [this.hospital],
          get_all: true,
          user_types: [
            "HOSPITAL_MARKETING_MANAGER",
            "SALES_DIRECTOR",
            "MARKETER",
            "REGIONAL_DIRECTOR",
          ],
          order_by: "first_name",
          order_type: "asc",
          status: "ACTIVE"
        });
        const res = JSON.parse(JSON.stringify(this.getAllUsers.data || []));

        // Deduplicate by email address since that's the unique identifier
        const uniqueSalesReps = res.reduce((acc, current) => {
          const existingIndex = acc.findIndex(item => item.email === current.email);
          if (existingIndex === -1) {
            acc.push(current);
          }
          return acc;
        }, []);
        
        this.filteredEmails = uniqueSalesReps;
      } catch (err) {
        console.error("Failed to load emails for user:", err);
        this.filteredEmails = [];
      }
    },
    onPopupClosed(isEmailSent) {
      // only reset if email was successfully sent
      if (isEmailSent) {
        this.resetFields();
      }
    },
    resetFields() {
      this.selectedEmails = [];
      this.selectedUser = [];
      this.hospital = "";
      this.filteredEmails = [];
      this.usersData = [];
      this.filteredHospitals = [...this.hospitalsData.data];
      this.selectKey += 1;  // Force re-render on full reset
    },
    async findPopup() {
      this.loading = true; // start loading
      try {
        if (!this.hospital) {
          this.$message.error("Please select an Ordering Facility");
          return;
        }
        if (!this.selectedUser || this.selectedUser.length === 0) {
          this.$message.error("Please select a Ordering Facility Admin");
          return;
        }

        await this.$store.dispatch("exceptionReport/fetchExceptionCasesByFacility", {
          facility_id: this.hospital,
        });

        this.exceptionDialogVisible = true;
      } catch (err) {
        console.error("Exception API failed:", err);
        this.$message.error("Failed to fetch exception cases. Please try again.");
      } finally {
          this.loading = false; // always stop loading
        }
    },
  },
  watch: {
    hospital(newVal) {
      if (!newVal) {
        this.filteredHospitals = [...this.hospitalsData.data];
        this.$nextTick(() => {
          if (this.$refs.hospitalSelect) {
            const input = this.$refs.hospitalSelect.$el.querySelector('input');
            if (input) {
              input.value = '';
              input.dispatchEvent(new Event('input', { bubbles: true }));
            }
            this.$refs.hospitalSelect.inputValue = '';
            this.$refs.hospitalSelect.query = '';
            // Reset scroll
            const dropdown = this.$refs.hospitalSelect.selectWrapper;
            if (dropdown) {
              dropdown.scrollTop = 0;
            }
            this.$refs.hospitalSelect.visible = false;
          }
        });
        this.selectedUser = [];
        this.selectedEmails = [];
        this.filteredEmails = [];
        this.usersData = [];
      }
    },
    async selectedUser(newVal) {
      if (!newVal || newVal.length === 0) {
        this.filteredEmails = [];
        this.selectedEmails = [];
        return;
      }
      // Load Sales Reps for the selected hospital (not dependent on selected users)
      await this.loadSalesRepEmails();
    }
  }
};
</script>


<style>
.download-button {
    min-height: 30px;
    max-height: 30px;
    padding: 5px 10px;
    font-size: 13px;
    background: #273480;
    color: #fff;
    font-weight: 500;
    border: none;
    border-radius: 6.4px;
    text-transform: uppercase;
    transition: all 0.2s ease-in-out; 
    margin-top: 18px;
} 
.download-button,
.download-button:hover,
.download-button:focus,
.download-button:active,
.download-button.is-disabled:focus {
  background: #273480 !important;
  color: #fff !important;
  border: none !important;
  opacity: 1 !important;   
  cursor: pointer !important;
}
</style>